module.exports = __webpack_public_path__ + "img/christmas-bee.89aecf6b.svg";